// Temporary entry comparison. Turn off after partner integration is verified.
export const ENTRY_DIAGNOSTICS_ENABLED = true
let entrySnapshot = null
let firstDisplayClaimed = false

function safeUrl (value) {
  if (!value) return '（空）'
  try {
    const url = new URL(String(value), window.location.origin)
    const sanitize = text => {
      const params = new URLSearchParams(text)
      Array.from(params.keys()).forEach(key => {
        if (/ticket|token|authorization|secret|password|openid|unionid|phone|mobile|idcard|idnumber|truename|personname|^code$|weburl|redirect|returnto|^url$/i.test(key)) {
          params.set(key, '（已脱敏）')
        }
      })
      return params.toString()
    }
    const search = sanitize(url.search)
    const hashIndex = url.hash.indexOf('?')
    const hash = hashIndex < 0 ? url.hash : url.hash.substring(0, hashIndex + 1) + sanitize(url.hash.substring(hashIndex + 1))
    return decodeURI(url.origin + url.pathname + (search ? '?' + search : '') + hash)
  } catch (error) { return '（地址无法解析，未展示原始内容）' }
}

export function captureEntryDiagnostics () {
  if (entrySnapshot) return
  const entries = window.performance && window.performance.getEntriesByType ? window.performance.getEntriesByType('navigation') : []
  const navigation = entries[0]
  entrySnapshot = {
    url: safeUrl(window.location.href),
    referrer: safeUrl(document.referrer),
    iframe: window.self !== window.top,
    navigation: navigation ? navigation.type : '浏览器未提供',
    redirects: navigation ? navigation.redirectCount : '浏览器未提供',
    ancestors: window.location.ancestorOrigins ? Array.from(window.location.ancestorOrigins).join(' → ') : '浏览器未提供'
  }
}

export function claimFirstDiagnostic () {
  if (!ENTRY_DIAGNOSTICS_ENABLED || firstDisplayClaimed) return false
  firstDisplayClaimed = true
  return true
}

export function entryDiagnosticText (reason) {
  captureEntryDiagnostics()
  let parentUrl = '跨域限制，无法读取（正常现象）'
  try { parentUrl = safeUrl(window.parent.location.href) } catch (error) {}
  const activation = window.navigator.userActivation
  return [
    '展示时机：' + reason,
    '首次进入地址：' + entrySnapshot.url,
    '当前地址：' + safeUrl(window.location.href),
    '来源 referrer：' + entrySnapshot.referrer,
    '是否 iframe：' + (entrySnapshot.iframe ? '是' : '否'),
    '外层地址：' + parentUrl,
    '上层来源：' + (entrySnapshot.ancestors || '（空）'),
    '导航类型：' + entrySnapshot.navigation,
    '重定向次数：' + entrySnapshot.redirects,
    '页面可见状态：' + document.visibilityState,
    '历史记录数：' + window.history.length,
    '当前交互信号：' + (activation ? String(activation.isActive) : '浏览器未提供'),
    '曾有交互信号：' + (activation ? String(activation.hasBeenActive) : '浏览器未提供'),
    '注意：交互信号和导航类型不能直接证明手动或自动打开。凭证和个人信息已脱敏。'
  ].join('\n\n')
}



// WEBPACK FOOTER //
// ./src/utils/entryDiagnostics.js